
















































import Vue from 'vue';
import CustomerField from '../components/fields/CustomerField.vue';
import AddCustomerField from '../components/fields/AddCustomerField.vue';
import customerVuex from '../../customer/vuex/common';
import CustomerProp from '../../customer/models/CustomerProp';
import customerClient from '../../customer/apis';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    CustomerField,
    AddCustomerField,
  },
  data() {
    return {
      showFields: false,
    };
  },
  methods: {
    loadPropsOfFields() {
      customerClient.getProps().success((r) => {
        this.$store.commit('SET_CUSTOMER_PROPS', r.props);
      });
    },
  },
  computed: {
    builtInProps(): CustomerProp[] {
      return this.customerState.props.filter((prop) => {
        return prop.builtIn;
      });
    },
    customProps(): CustomerProp[] {
      return this.customerState.props.filter((prop) => {
        return !prop.builtIn;
      });
    },
  },
  mounted() {
    this.loadPropsOfFields();
  },
});
